import CompareApi from './_compareApi';
import httpClient from '@/apis/base/httpclient';

class CompareConvertAPI extends CompareApi {
  constructor() {
    super();
  }
  controllerName = 'CompareConverts';

  /**
   * Lấy dữ liệu đối chiếu sau khi convert
   * DDTHANG 28.11.2022
   */
  getDataCompareConvert(param) {
    let request = {
      url: this.getAPIUrl() + '/DataCompare',
      data: param,
    };

    return httpClient.getAsync(request);
  }
}

export default new CompareConvertAPI();
